import { Injectable } from "@angular/core";
import * as _ from 'lodash';
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { map } from "rxjs/operators";
import { of, Observable } from 'rxjs';

@Injectable()
export class DateService {

   accessDate;

   className = 'DateService';

   constructor(private translateService: TranslateService) { }

   formatDate(date, format = "DD/MM/YYYY", textWithTime = false, nearDates = true): Observable<any> {

      if (date) {
         let oMoment = moment(date, "YYYY-MM-DD");
         if (oMoment.isValid()) {
            if (!nearDates) {
               return of(oMoment.format(format));
            }
            if (moment().diff(oMoment, "days") === 0) {
               return this.translateService.stream("DATE.TODAY").pipe(map(translate => {
                  return `${translate}${textWithTime ? ", " + oMoment.format("HH:mm") : ""}`;
               }))
            } else if (moment().diff(oMoment, "days") === -1) {
               return this.translateService.stream("DATE.TOMORROW").pipe(map(translate => {
                  return `${translate}${textWithTime ? ", " + oMoment.format("HH:mm") : ""}`;
               }))
            } else if (moment().diff(oMoment, "days") === 1) {
               return this.translateService.stream("DATE.YESTERDAY").pipe(map(translate => {
                  return `${translate}${textWithTime ? ", " + oMoment.format("HH:mm") : ""}`;
               }))
            } else {
               return of(oMoment.format(format));
            }
         } else {
            return this.translateService.stream("DATE.INVALID").pipe(map(translate => {
               return translate;
            }));
         }
      }
      else {
         return of(null);
      }
   }

   getElapsedTime() {
      if (!this.accessDate) {
         return 0
      } else {
         return moment().diff(this.accessDate, 'minutes');
      }
   }

   setAccessDate() {
      this.accessDate = moment();
   }
}
